// Phase 1A Phase 9C.2 — ACC fixture lifecycle icon definitions.
//
// 7 lifecycle glyphs covering the future fixtures.analysis_status
// state machine. Empty queue → preliminary → awaiting_lineup →
// complete → settled. rejected / invalidated terminate the
// lifecycle from different reasons.

import type { IconDef } from "./icon-types.ts";

export const LIFECYCLE_ICONS: Record<string, IconDef> = {
  "lifecycle.pending": {
    // Empty queue circle — distinct from preliminary by absence of
    // internal mark.
    key: "lifecycle.pending",
    shapes: [{ type: "circle", cx: 12, cy: 12, r: 7 }],
  },
  "lifecycle.preliminary": {
    // Dashed circle (early-active, signal under construction).
    key: "lifecycle.preliminary",
    shapes: [
      { type: "path", d: "M5 12 A7 7 0 0 1 12 5" },
      { type: "path", d: "M14 5.3 A7 7 0 0 1 18.7 10" },
      { type: "path", d: "M19 14 A7 7 0 0 1 14 18.7" },
      { type: "path", d: "M10 18.7 A7 7 0 0 1 5.3 14" },
    ],
  },
  "lifecycle.awaiting_lineup": {
    // Three dots vertically aligned — distinct from horizontal
    // readiness.lineup_pending.
    key: "lifecycle.awaiting_lineup",
    shapes: [
      { type: "circle", cx: 12, cy: 6, r: 1.4, filled: true },
      { type: "circle", cx: 12, cy: 12, r: 1.4, filled: true },
      { type: "circle", cx: 12, cy: 18, r: 1.4, filled: true },
    ],
  },
  "lifecycle.complete": {
    key: "lifecycle.complete",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7 },
      { type: "polyline", points: "9,12 11,14 15,10" },
    ],
  },
  "lifecycle.settled": {
    key: "lifecycle.settled",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7, filled: true },
      { type: "polyline", points: "9,12 11,14 15,10", strokeWidth: 2.4 },
    ],
  },
  "lifecycle.rejected": {
    key: "lifecycle.rejected",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7 },
      { type: "line", x1: 8, y1: 12, x2: 16, y2: 12, strokeWidth: 2.2 },
    ],
  },
  "lifecycle.invalidated": {
    key: "lifecycle.invalidated",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7 },
      { type: "line", x1: 12, y1: 7, x2: 12, y2: 17, strokeWidth: 2.2 },
    ],
  },
};
